// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'subscriptions',
        component: () =>
            import('@/pages/[organisation]/settings/subscriptions/subscriptions.vue'),
        name: 'settings.subscriptions.search-subscriptions',
        meta: {
            loginRequired: true,
            permission: 'access.saas.subscription-invoice.view-subscriptions',
        },
    },
];
